import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type { AssistantBatchesResponse, CreateBatchResponse } from './types';

export const getAssistantBatches = (params: {
  accountId: string;
  projectId: string;
}) => {
  return doGet<AssistantBatchesResponse>(
    generateNextPath(ENDPOINTS.CALL_BATCHES, params),
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};

export const deleteAssistantBatch = (params: {
  accountId: string;
  projectId: string;
  batchId: string;
}) => {
  return doDelete(
    generateNextPath(ENDPOINTS.CALL_BATCH, params),
    LOGGER_TYPE.ANALYTICS,
    {
      prefix: 'nebula',
    },
  );
};

export const createManualAssistantBatch = (
  params: {
    accountId: string;
    projectId: string;
  },
  payload: {
    batch_name: string;
    task_id: string;
    query: string;
    conversation_ids: string[];
  },
) => {
  return doPost<CreateBatchResponse>(
    generateNextPath(ENDPOINTS.CALL_MANUAL_BATCH, params),
    LOGGER_TYPE.ANALYTICS,
    payload,
    { prefix: 'nebula' },
  );
};

export const createRandomisedAssistantBatch = (
  params: {
    accountId: string;
    projectId: string;
  },
  payload: {
    batch_name: string;
    task_id: string;
    query: string;
    num_conversations: number;
  },
) => {
  return doPost<CreateBatchResponse>(
    generateNextPath(ENDPOINTS.CALL_RANDOMISED_BATCH, params),
    LOGGER_TYPE.ANALYTICS,
    payload,
    { prefix: 'nebula' },
  );
};
